import React from 'react';
import DefaultPaymentInfo from '../../../PaymentInfo/components/DefaultPaymentInfo';

const DefaultPurchaseFlow = ({ onSubmit, errorMessage, props }) => {
  return <DefaultPaymentInfo onSubmit={onSubmit} errorMessage={errorMessage} {...props} />;
};

export default DefaultPurchaseFlow;

